<div class="min-h-screen bg-gray-50 flex flex-col">
  <!-- Navigation Header -->
  <nav class="bg-white shadow">
    <div class="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between h-16">
        <div class="flex">

          <!-- Logo -->
          <div class="shrink-0 flex items-center">
            <div class="flex items-center space-x-2">
              <img src="assets/resource-nexus-logo.svg" alt="ResourceNexus Logo" width="300" height="80" class="h-18 w-auto" style="min-width:300px;" />
              <span class="sr-only">ResourceNexus</span>
            </div>
          </div>

          <!-- Primary Navigation -->
          <div class="hidden sm:ml-6 sm:flex sm:space-x-8">
            <a
              routerLink="/timeline"
              routerLinkActive="border-indigo-500 text-gray-900"
              class="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              >
              <ng-icon name="bars3" class="w-4 h-4 mr-2"></ng-icon>
              Timeline
            </a>

            <a
              routerLink="/resource-assignments"
              routerLinkActive="border-indigo-500 text-gray-900"
              class="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              >
              <ng-icon name="share" class="w-4 h-4 mr-2"></ng-icon>
              Assignments
            </a>

            <a
              routerLink="/resources"
              routerLinkActive="border-indigo-500 text-gray-900"
              class="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              >
              <ng-icon name="users" class="w-4 h-4 mr-2"></ng-icon>
              Resources
            </a>

            <a
              routerLink="/projects"
              routerLinkActive="border-indigo-500 text-gray-900"
              class="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              >
              <ng-icon name="bookOpen" class="w-4 h-4 mr-2"></ng-icon>
              Projects
            </a>

            <a
              routerLink="/customers"
              routerLinkActive="border-indigo-500 text-gray-900"
              class="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              >
              <ng-icon name="buildingOffice2" class="w-4 h-4 mr-2"></ng-icon>
              Customers
            </a>

            <a
              routerLink="/roles"
              routerLinkActive="border-indigo-500 text-gray-900"
              class="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
              >
              <ng-icon name="clipboardDocumentList" class="w-4 h-4 mr-2"></ng-icon>
              Roles
            </a>

            <!-- Admin dropdown — OrganizationAdministrator only -->
            @if (isAuthenticated() && appRoleService.isOrganizationAdministrator()) {
              <div class="relative flex items-stretch">
                <button
                  type="button"
                  class="admin-btn inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium focus:outline-none"
                  [class]="isAdminActive()
                    ? 'border-indigo-500 text-gray-900'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'"
                  aria-label="Open admin menu"
                  data-testid="admin-menu-btn"
                  (click)="showAdminMenu.set(!showAdminMenu())"
                  >
                  <ng-icon name="cog6Tooth" class="w-4 h-4 mr-2"></ng-icon>
                  Admin
                  <ng-icon name="chevronDown" class="w-3 h-3 ml-1"></ng-icon>
                </button>
                @if (showAdminMenu()) {
                  <div
                    class="admin-dropdown origin-top-left absolute left-0 top-full mt-0 w-44 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
                    >
                    <div class="py-1">
                      <a
                        routerLink="/admin/departments"
                        (click)="showAdminMenu.set(false)"
                        class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        data-testid="manage-departments-link"
                        >
                        Departments
                      </a>
                      <a
                        routerLink="/admin/access-control"
                        (click)="showAdminMenu.set(false)"
                        class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        data-testid="manage-access-control-link"
                        >
                        Access control
                      </a>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>

        <!-- Right side actions -->
        <div class="hidden sm:ml-6 sm:flex sm:items-center gap-3">
          <!-- User avatar menu -->
          @if (isAuthenticated()) {
            <div class="ml-3 relative">
              <button
                type="button"
                class="avatar-btn flex items-center rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                aria-label="Open user menu"
                (click)="showUserMenu.set(!showUserMenu())"
                >
                <ng-icon name="userCircle" size="40px" class="text-indigo-600" />
              </button>
              @if (showUserMenu()) {
                <div
                  class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50 animate-fade-in"
                  tabindex="-1"
                  (focusout)="showUserMenu.set(false)"
                  >
                  <div class="py-3 px-4 border-b border-gray-100">
                    <div class="font-semibold text-gray-900 text-base truncate">{{ displayName() }}</div>
                    <div class="text-xs text-gray-500 truncate">{{ userEmail() }}</div>
                  </div>
                  <div class="py-1">
                    <button
                      (click)="onLogout(); showUserMenu.set(false)"
                      class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center"
                      >
                      <ng-icon name="arrowRightOnRectangle" class="w-4 h-4 mr-2 text-indigo-600" />
                      Logout
                    </button>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="ml-3 relative">
              <a
                routerLink="/login"
                class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                <ng-icon name="arrowRightOnRectangle" class="w-4 h-4 mr-1"></ng-icon>
                Login
              </a>
            </div>
          }
        </div>

        <!-- Mobile menu button -->
        <div class="flex items-center sm:hidden">
          <button
            type="button"
            class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
            aria-controls="mobile-menu"
            aria-expanded="false"
            >
            <span class="sr-only">Open main menu</span>
            <ng-icon name="bars3" class="block h-6 w-6"></ng-icon>
          </button>
        </div>
      </div>
    </div>
  </nav>

  <!-- Main Content Area -->
  <main class="flex-1 min-h-0">
    @if (authService.isLoading()) {
      <!-- Loading spinner during auth check -->
      <div class="flex items-center justify-center min-h-screen">
        <div class="text-center">
          <div class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
          <p class="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    } @else {
      <router-outlet></router-outlet>
    }
  </main>

  <!-- Footer -->
  <footer class="bg-white border-t border-gray-200">
    <div class="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <p class="text-sm text-gray-500">
            © 2026 New Nexus.
          </p>
        </div>
      </div>
    </div>
  </footer>
</div>
